import { URL } from "../config/URL.Config";
import AxiosServices from "./AxiosServices";

const instance = new AxiosServices().getServiceInstance();

export const getUserTransaction = async (userData: any) => {
  const userTransaction = await instance.post(
    URL.recognition.getUserTransaction,
    userData
  );
  return userTransaction;
};

export const getUserRecognitionDetails = async (userId: string) => {
  const userTransaction = await instance.get(
    URL.recognition.getUserRecognitionDetails(userId)
  );
  return userTransaction.data.data;
};

export const getRecognitionHistory = async (filters: any) => {
  const userTransaction = await instance.post(
    URL.recognition.getRecognitionHistory,
    filters
  );
  return userTransaction.data.data;
};
